import * as React from 'react'

const SvgElephantSadSuicase = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={184}
    height={120}
    viewBox="0 0 184 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#ElephantSadSuicase_svg__a)">
      <path d="M113.517 0Z" fill="#9865FC" />
      <path
        d="M167.187 85.407h-7.353a5.116 5.116 0 0 1-5.11-5.11V58.08a5.116 5.116 0 0 1 5.11-5.11h7.353a5.116 5.116 0 0 1 5.11 5.11v22.217a5.116 5.116 0 0 1-5.11 5.11ZM159.829 55.3a2.776 2.776 0 0 0-2.774 2.774v22.217a2.776 2.776 0 0 0 2.774 2.774h7.353a2.776 2.776 0 0 0 2.775-2.774V58.075a2.78 2.78 0 0 0-2.775-2.774h-7.353ZM153.619 118.691a2.93 2.93 0 1 0 0-5.859 2.93 2.93 0 0 0 0 5.859Z"
        fill="#440A78"
      />
      <path
        d="M153.619 116.603a.842.842 0 1 0 0-1.684.842.842 0 0 0 0 1.684Z"
        fill="#E1CEFF"
      />
      <path
        d="M173.027 118.691a2.93 2.93 0 1 0 0-5.86 2.93 2.93 0 0 0 0 5.86Z"
        fill="#440A78"
      />
      <path
        d="M173.027 116.603a.842.842 0 1 0 0-1.684.842.842 0 0 0 0 1.684Z"
        fill="#E1CEFF"
      />
      <path
        d="m177.661 106.493-.02-28.903a6.326 6.326 0 0 0-6.331-6.323l-21.394.015a6.328 6.328 0 0 0-6.323 6.331l.021 28.904a6.326 6.326 0 0 0 6.331 6.322l21.394-.014a6.327 6.327 0 0 0 6.322-6.332Z"
        fill="#AC94F0"
      />
      <path
        d="m183.067 106.493-.02-28.903a6.326 6.326 0 0 0-6.331-6.323l-21.395.015a6.327 6.327 0 0 0-6.322 6.331l.02 28.904a6.327 6.327 0 0 0 6.331 6.322l21.395-.014a6.327 6.327 0 0 0 6.322-6.332Z"
        fill="#E1CEFF"
      />
      <path
        d="m179.364 76.983-1.168 31.614-1.168-31.614c-.024-1.587 2.36-1.597 2.336 0ZM155.021 76.983l-1.168 31.614-1.168-31.614c-.025-1.587 2.36-1.597 2.336 0ZM161.109 76.983l-1.168 31.614-1.168-31.614c-.025-1.587 2.36-1.597 2.336 0ZM167.192 76.983l-1.168 31.614-1.168-31.614c-.024-1.587 2.361-1.597 2.336 0ZM173.281 76.983l-1.168 31.614-1.168-31.614c-.025-1.587 2.36-1.597 2.336 0Z"
        fill="#7130C9"
      />
      <path
        d="M109.326 44.273ZM110.811 44.015a45.842 45.842 0 0 0 13.851-5.037c.097-.053.194-.112.287-.165-.098.053-.195.112-.287.165a45.938 45.938 0 0 1-13.851 5.037Z"
        fill="#440A78"
      />
      <path
        d="M57.13 120a20.9 20.9 0 0 1-13.67-5.047c-8.93 5.076-21.224 4.521-21.224 4.521l-2.23-5.776s13.457.37 17.429-7.252C14.342 41.363 65.954 22.791 65.954 22.791s39.309 27.152 58.708 16.27c.097-.054.194-.112.287-.166v-.014L112.096 3.616a2.793 2.793 0 0 0-.234-.491l17.243.004c7.855 0 15.058 4.42 18.572 11.447 7.884 15.773 18.975 46.41 10.536 82.833h-10.244c1.455-51.486-20.319-50.342-20.319-50.342L153.799 120h-27.565l-21.239-33.493L116.977 120H57.13Z"
        fill="#7130C9"
      />
      <path
        d="M105.399 44.72a47.319 47.319 0 0 0 5.417-.705 45.84 45.84 0 0 0 13.851-5.037c.097-.053.194-.112.287-.165a40.493 40.493 0 0 1-14.669 2.462 40.72 40.72 0 0 1-20.489-5.99 40.87 40.87 0 0 1-5.777-4.274 40.575 40.575 0 0 1-4.127-4.248c.103.126.205.253.307.374-.107-.121-.204-.248-.307-.374a40.513 40.513 0 0 1-4.876-7.267c-2.161.497-9.057 3.27-9.057 3.27 4.59 13.642 20.328 22.466 37.284 22.057h.112c.681-.02 1.363-.053 2.044-.097v-.005Z"
        fill="#440A78"
      />
      <path
        d="M89.791 35.284a40.784 40.784 0 0 0 20.489 5.991 40.493 40.493 0 0 0 14.669-2.462L112.096 3.538a2.866 2.866 0 0 0-.234-.491 3.108 3.108 0 0 0-3.757-1.363L72.49 14.664l2.526 4.832c4.355 8.327 10.828 13.068 11.802 13.788a39.3 39.3 0 0 0 2.978 2.005l-.005-.005Z"
        fill="#9865FC"
      />
      <path
        d="M129.986 23.263a3.991 3.991 0 1 0 7.252-3.338 13.488 13.488 0 0 1-7.252 3.338Z"
        fill="#fff"
      />
      <path
        d="M22.235 119.45H.57a.564.564 0 0 1-.375-.988c3.767-3.319 16.24-13.388 19.817-4.794l2.23 5.777-.006.005ZM61.175 65.804l20.64.57c1.036.033 5.572.135 6.502.199 5.105.253 10 3.12 12.751 7.383 1.776 2.579 2.764 6.886 3.82 9.826a64244.01 64244.01 0 0 0 9.661 29.424l-11.131-28.899-1.854-4.818c-.565-1.514-1.217-3.08-2.185-4.375-2.799-3.967-7.602-6.196-12.406-5.884-3.377.092-22.027.603-25.798.71-2.774.005-2.813-4.122 0-4.127v-.01ZM128.049 117.645c.043-5.193 7.48-5.135 7.743 0h-1.066c-.107-2.234 1.839-4.264 4.093-4.273 2.321-.112 4.497 1.907 4.477 4.273h-1.835c-.082-3.86 4.867-5.845 7.34-2.862.686.818.963 1.908.788 2.862-.02.097-.161.097-.18 0-.657-3.704-5.884-3.83-6.118.043-.063 1.203-1.825 1.159-1.834-.043.082-2.478-2.916-3.782-4.721-2.078-.57.525-.92 1.28-.949 2.078a.54.54 0 0 1-.555.554.533.533 0 0 1-.516-.554 3.076 3.076 0 0 0-.822-2.205c-1.957-2.151-5.578-.681-5.675 2.205 0 .112-.18.112-.18 0h.01ZM89.353 117.645c.044-5.193 7.48-5.135 7.743 0H96.03c-.107-2.234 1.84-4.264 4.093-4.273 2.322-.112 4.497 1.907 4.478 4.273h-1.835c-.083-3.86 4.867-5.845 7.339-2.862.686.818.964 1.908.788 2.862-.019.097-.16.097-.18 0-.657-3.704-5.884-3.83-6.117.043-.064 1.203-1.825 1.159-1.835-.043.083-2.478-2.915-3.782-4.72-2.078a2.99 2.99 0 0 0-.95 2.078.54.54 0 0 1-.555.554.533.533 0 0 1-.516-.554 3.073 3.073 0 0 0-.822-2.205c-1.956-2.151-5.577-.681-5.675 2.205 0 .112-.18.112-.18 0h.01ZM85.917 120l-7.621-21.453C78.296 110.398 68.82 120 57.13 120"
        fill="#440A78"
      />
      <path
        d="M38.612 85.407h-7.354a5.116 5.116 0 0 1-5.11-5.11V58.08a5.116 5.116 0 0 1 5.11-5.11h7.354a5.116 5.116 0 0 1 5.11 5.11v22.217a5.116 5.116 0 0 1-5.11 5.11ZM31.258 55.3a2.776 2.776 0 0 0-2.773 2.774v22.217a2.776 2.776 0 0 0 2.774 2.774h7.353a2.776 2.776 0 0 0 2.774-2.774V58.075a2.78 2.78 0 0 0-2.774-2.774h-7.354ZM25.044 118.691a2.93 2.93 0 1 0 0-5.86 2.93 2.93 0 0 0 0 5.86Z"
        fill="#540C06"
      />
      <path
        d="M25.044 116.603a.842.842 0 1 0 0-1.684.842.842 0 0 0 0 1.684Z"
        fill="#FFC103"
      />
      <path
        d="M44.452 118.691a2.93 2.93 0 1 0 0-5.86 2.93 2.93 0 0 0 0 5.86Z"
        fill="#540C06"
      />
      <path
        d="M44.452 116.603a.842.842 0 1 0 0-1.684.842.842 0 0 0 0 1.684Z"
        fill="#FFC103"
      />
      <path
        d="m49.084 106.489-.02-28.904a6.327 6.327 0 0 0-6.331-6.323l-21.395.015a6.327 6.327 0 0 0-6.322 6.332l.02 28.903a6.327 6.327 0 0 0 6.331 6.323l21.394-.015a6.327 6.327 0 0 0 6.323-6.331Z"
        fill="#FDF49A"
      />
      <path
        d="m54.49 106.489-.02-28.904a6.327 6.327 0 0 0-6.332-6.323l-21.394.015a6.327 6.327 0 0 0-6.322 6.332l.02 28.903a6.327 6.327 0 0 0 6.33 6.323l21.395-.015a6.327 6.327 0 0 0 6.323-6.331Z"
        fill="#FFC103"
      />
      <path
        d="m50.794 76.983-1.168 31.614-1.168-31.614c-.024-1.587 2.36-1.597 2.336 0ZM26.445 76.983l-1.168 31.614-1.168-31.614c-.024-1.587 2.36-1.597 2.336 0ZM32.534 76.983l-1.168 31.614-1.168-31.614c-.025-1.587 2.36-1.597 2.336 0ZM38.622 76.983l-1.168 31.614-1.168-31.614c-.025-1.587 2.36-1.597 2.336 0ZM44.705 76.983l-1.168 31.614-1.168-31.614c-.024-1.587 2.36-1.597 2.336 0Z"
        fill="#B28509"
      />
    </g>
    <defs>
      <clipPath id="ElephantSadSuicase_svg__a">
        <path fill="#fff" d="M0 0h183.072v120H0z" />
      </clipPath>
    </defs>
  </svg>
)

export default SvgElephantSadSuicase
